export const workStreamSenseMaking = {
  mode: {
    chooseTitle: 'What kind of work is this?',
    chooseDescription:
      'Hunches use a short scaffold and triangles. Method streams are for work where you already have a process in mind.',
    ambiguousTitle: 'This is still a hunch',
    ambiguousDescription:
      'We do not yet know the process. Multiple-choice and triangles — no essay.',
    clearTitle: 'We have a process in mind',
    clearDescription:
      'Enough is known to name intention, silence, tasks, and who holds continuity.',
  },
  ambiguous: {
    title: 'Create a hunch',
    editTitle: 'Edit hunch',
    description:
      'Describe the work with choices and triangles. You can turn it into a method stream later without starting again.',
    hunchLabel: 'Hunch',
    hunchPlaceholder: 'One line: what you think this work might be',
    promote: 'This has become clear enough',
    promoteHint:
      'The scaffold suggests a method is now visible. Promote to fill in tasks, dates, and authority.',
    demote: 'This is more of a hunch',
    demoteHint:
      'If this is still exploratory, switch to the hunch scaffold. Nothing is saved until you update.',
    demoteOverwriteWarning:
      'This work stream already has method details such as tasks, dates, or authority. Saving as a hunch keeps those fields, but the stream will show as a hunch. Continue?',
    save: 'Create hunch',
    triadRequired: 'Place at least the first triangle (or mark it as not applicable).',
    silenceRequired: 'Choose what silence means.',
    holdingRequired: 'Choose why this is not moving, or assign a continuity holder.',
  },
  scaffold: {
    selectAllThatApply: 'Select all that apply',
    chooseOne: 'Choose one',
    whyExists: {
      title: 'Why this exists',
      hunch: 'A hunch — we think there might be something here',
      opportunity: 'An external opportunity showed up',
      recurring_pain: 'A recurring pain that keeps coming back',
      someone_asked: 'Someone asked us to look',
      strategic_bet: 'A strategic bet',
    },
    whyNotMoving: {
      title: 'Why it is not moving',
      no_capacity: 'No one currently has capacity',
      dont_know_how: "Don't yet know how to start",
      waiting_decision: 'Waiting on a decision',
      waiting_external: 'Waiting on something external',
      parked_on_purpose: 'Parked on purpose',
      needs_particular_person: 'Needs a particular person or skill',
    },
    silenceMeans: {
      title: 'What silence means',
      leave_it: 'Leave it — no work expected unless someone opts in',
      task_help: 'Task-level help is welcome',
      nudge_decision: 'Nudge only when a decision point arrives',
      available_to_adopt: 'Available for someone to adopt',
    },
    knowMoreWhen: {
      title: 'We will know more when',
      conversation: 'A conversation has happened',
      timeboxed_probe: 'A time-boxed probe has run',
      someone_takes_continuity: 'Someone takes continuity',
      named_decision: 'A named decision is made',
      first_tasks: 'The first tasks can be written',
    },
    processClarity: {
      title: 'How clear is the process',
      not_yet: 'Not yet — still exploratory',
      few_moves: 'A few possible moves',
      can_name_tasks: 'We can name tasks',
      can_follow_method: 'We can follow a method',
    },
  },
  triads: {
    intro:
      'Place a mark in each triangle. The centre means all three are equally in play — not “I don’t know”. Use “doesn’t apply” if a triangle is the wrong question.',
    none: "Doesn't apply",
    placedHint: 'Closer to a corner means that pull is stronger.',
    cynefin: {
      prompt: 'This work currently calls for…',
      pointA: 'Find a right approach',
      pointB: 'Discover by trying',
      pointC: 'Act first to grasp it',
      pointAHint: 'There is a known or knowable way to do this well.',
      pointBHint: 'We find the way by probing and learning as we go.',
      pointCHint: 'We need to do something so the work becomes visible.',
    },
    scaling: {
      prompt: 'This work currently needs…',
      pointA: 'Keep it as a one-off here',
      pointB: 'Make it take-on-able',
      pointC: 'Make it repeatable',
      pointAHint: 'Try it in this situation, with the people already in it — do not copy it yet.',
      pointBHint: 'Give it enough shape that someone else could take it on.',
      pointCHint: 'Turn it into a version that could be run again in another place or time.',
    },
    enough: {
      prompt: 'Enough, for now, would mean…',
      pointA: 'Finish a known piece',
      pointB: 'Reach a judgement',
      pointC: 'Learn the next move',
      pointAHint: 'Completing something we already recognise as a piece of work.',
      pointBHint: 'Being able to stand behind a decision.',
      pointCHint: 'Knowing what to do next, even if the work is not finished.',
    },
  },
  landscape: {
    tab: 'Landscape',
    title: 'Work stream landscape',
    description:
      'Triangles from streams that have been signified. Colour shows whether they are unheld, held, or completed — not a score.',
    empty: 'No streams have been placed on this triangle yet.',
    signified: '{{placed}} of {{total}} streams signified',
    filterAll: 'All',
    filterUnheld: 'Unheld',
    filterHeld: 'Held',
    filterCompleted: 'Completed',
    legendUnheld: 'Unheld',
    legendHeld: 'Held',
    legendCompleted: 'Completed',
    triadCynefin: 'What this work calls for',
    triadScaling: 'What this work needs',
    triadEnough: 'What enough would mean',
  },
  chips: {
    hunch: 'Hunch',
    method: 'Method',
  },
  defaultTasks: {
    title: 'Starter tasks',
    description:
      'Small things someone could do to find out more. Remove any that do not apply.',
    organiseMeeting: 'Organise a meeting about this',
    talkToSomeone: 'Talk to someone who might know more',
    prototypeProbe: 'Prototype a probe that will deliver more information',
  },
}
